import { benefits } from '@/mocks/homeData';

export default function BenefitsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-14">
          {/* Left label */}
          <div className="lg:w-1/4 flex-shrink-0">
            <p className="text-xs tracking-[0.3em] uppercase text-foreground-500 font-medium mb-1">
              ITAOBUY / HOMES
            </p>
            <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight mt-2">
              Smart Shopping,<br />Simplified
            </h2>
            <p className="text-sm text-foreground-600 mt-3 max-w-xs">
              The <strong>itaobuyspreadsheet</strong> methodology transforms complex shopping decisions into a streamlined, data-driven process.
            </p>
          </div>

          {/* Benefit cards */}
          <div className="lg:w-3/4 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {/* Card 1 - Dark */}
            <div className="rounded-xl bg-foreground-950 p-6 md:p-7 flex flex-col justify-between min-h-[280px]">
              <div>
                <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-foreground-800 text-accent-400 text-xs font-bold mb-5">
                  01
                </span>
                <h3 className="text-xl md:text-2xl font-heading text-background-50 mb-3">
                  {benefits[0].title}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed">
                  {benefits[0].description}
                </p>
              </div>
            </div>

            {/* Card 2 - Image background */}
            <div className="rounded-xl overflow-hidden relative min-h-[280px]">
              <img
                src="https://readdy.ai/api/search-image?query=Laptop%20screen%20showing%20product%20comparison%20spreadsheet%20on%20minimal%20cream%20desk%2C%20warm%20natural%20lighting%2C%20soft%20shadows%2C%20clean%20organized%20workspace%2C%20editorial%20photography%2C%20neutral%20warm%20aesthetic%2C%20professional%20modern%20setup&width=600&height=800&seq=benefit-compare-01&orientation=portrait"
                alt="itaobuyspreadsheet comparison feature"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40"></div>
              <div className="relative z-10 p-6 md:p-7 flex flex-col justify-end h-full">
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/20 text-white text-xs mb-4 w-fit">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-flashlight-line text-xs"></i>
                  </span>
                  Auto-Compare
                </span>
                <h3 className="text-xl md:text-2xl font-heading text-white mb-2">
                  {benefits[1].title}
                </h3>
              </div>
            </div>

            {/* Card 3 - Light */}
            <div className="rounded-xl bg-accent-100 p-6 md:p-7 flex flex-col justify-between min-h-[280px]">
              <div>
                <h3 className="text-3xl md:text-4xl font-heading text-accent-600 mb-3">
                  {benefits[2].title}
                </h3>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {benefits[2].description}
                </p>
              </div>
              <div className="mt-4">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20product%20flat%20lay%20with%20watch%20and%20small%20accessories%20on%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography%2C%20warm%20neutral%20aesthetic%2C%20elegant%20minimal%20composition&width=300&height=200&seq=benefit-save-01&orientation=landscape"
                  alt="itaobuyspreadsheet time saving"
                  className="w-full h-24 object-cover rounded-lg object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}